import React from "react";
import { default as Head } from "next/head";
import { useIntl } from "react-intl";
import { IStory } from "~/types/types";
import getCoverUrl from "~/components/story/utils/getCoverUrl";
import SeoHead from "~/components/seo/SeoHead";

interface IStoryPageSeoProps {
  story: Pick<IStory, "introduction" | "title" | "medias" | "verticalCover">;
}

export default function StoryPageSeo({ story }: IStoryPageSeoProps) {
  const intl = useIntl();
  const imageUrl = getCoverUrl(story);

  return (
    <>
      <SeoHead
        title={`${story.title} - Govlaunch ${intl.formatMessage({ defaultMessage: "Stories", id: "Ldxym4" })}`}
        description={story.introduction?.substr(0, 150) || story.title}
      />
      <Head>
        <meta name="twitter:card" content={imageUrl ? "summary_large_image" : "summary"} />
        <meta name="twitter:image" content={imageUrl || ""} />

        <meta property="og:image" content={imageUrl || ""} />
      </Head>
    </>
  );
}
